import React from "react";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";
import JobShiftEmergencyProcedureHeader from "./JobShiftEmergencyProcedureHeader";
import JobShiftEmergencyProcedureTitleBand from "./JobShiftEmergencyProcedureTitleBand";
import EmergencyProcedureDetailsSection from "./sections/EmergencyProcedureDetailsSection";
import EmergencyProcedureDocumentAuthorization from "./sections/EmergencyProcedureDocumentAuthorization";
import ProcedureDynamicSections from "./sections/ProcedureDynamicSections";
import EmergencyProcedureRescueConfigurationAppendix from "./sections/EmergencyProcedureRescueConfigurationAppendix";

const getProcedureList = (procedures) => (
  procedures
  && procedures.emergency_procedures
  && Array.isArray(procedures.emergency_procedures.procedures)
    ? procedures.emergency_procedures.procedures.filter((procedure) => procedure && procedure.toggle === 1)
    : []
);

export { getProcedureList };

export default function JobShiftEmergencyProceduresDocument({ procedures, sections, context }) {
  const procedureList = getProcedureList(procedures);

  return (
    <div className={styles.PreviewWrap}>
      <main>
        <div style={{ background: "transparent" }}>
          {procedureList.map((procedure, index) => (
            <div
              key={procedure.id || procedure.procedure_id || procedure.document_number || index}
              className={styles.PreviewDoc}
              style={{
                minHeight: "180px",
                marginBottom: index === procedureList.length - 1 ? 0 : "24px"
              }}
            >
              <JobShiftEmergencyProcedureHeader procedure={procedure} sections={sections} context={context} />
              <JobShiftEmergencyProcedureTitleBand procedure={procedure} />
              <EmergencyProcedureDetailsSection procedure={procedure} sections={sections} context={context} />
              <EmergencyProcedureDocumentAuthorization procedure={procedure} sections={sections} />
              <ProcedureDynamicSections procedure={procedure} swmsSections={sections} />
              {Array.isArray(procedure.sections) ? procedure.sections
                .filter((section) => section && section.type === "rescue_configuration_media" && section.data && section.data.toggle === 1)
                .map((section) => (
                  <EmergencyProcedureRescueConfigurationAppendix key={section.id} section={section} sections={sections} />
                )) : null}
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
